const header = document.querySelector("[data-header]");

const closeMenuButton =
  document.querySelector<HTMLElement>("[data-menu-close]");
const openMenuButton = document.querySelector<HTMLElement>("[data-menu-open]");

const openMenu = () => {
  header?.classList.add("is-open");
  document.body.classList.add("disallow-scroll");
};

const closeMenu = () => {
  header?.classList.remove("is-open");
  document.body.classList.remove("disallow-scroll");
};

const hideMenuButtons = () => {
  openMenuButton?.classList.add("is-hidden");
  closeMenuButton?.classList.add("is-hidden");
};

const onResize = () => {
  const iframes = document.querySelectorAll<HTMLIFrameElement>("iframe");

  iframes.forEach((iframe) => {
    if (
      !iframe.src.includes("facebook.com/plugins/video") &&
      !iframe.src.includes("youtube") &&
      !iframe.src.includes("vimeo.com") &&
      !iframe.src.includes("twitter.com")
    )
      // Only resize to 16/9 in Facebook, Youtube and Twitter iframes
      return;

    const width = iframe.offsetWidth;
    const height = (width * 9) / 16;
    iframe.style.height = `${height}px`;
  });
};

const isMenuOpen: boolean = !!header?.classList.contains("is-open");

(() => {
  window.addEventListener("resize", onResize);
  openMenuButton?.addEventListener("click", openMenu);
  closeMenuButton?.addEventListener("click", closeMenu);
  setTimeout(() => onResize(), 100);
})();

export {
  openMenu,
  closeMenu,
  isMenuOpen,
  openMenuButton,
  closeMenuButton,
  hideMenuButtons,
};
